import { useParams } from "react-router-dom";
import { Grid, Skeleton } from "@mui/material";
import { useState, useEffect, Fragment } from "react";

import { useAxios } from "../../hooks";
import { PageHeader } from "../../components";
import UserList from "./user list components/UserList";

export default function SuperAdminUsers() {
  const axios = useAxios();
  const params = useParams();

  const brandID = params.brandID || "";

  const [filterBy, setFilterBy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [usersData, setUsersData] = useState({
    users: [],
    brand: {},
  });

  useEffect(() => {
    setLoading(true);
    axios({
      url: "/users?brandId=" + brandID,
    }).then((response) => {
      if (response.status) {
        setUsersData({
          users: response.data.users,
          brand: response.data.brand,
        });
      }
      setLoading(false);
    });
  }, [axios, brandID]);

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12} display="flex">
          {loading ? (
            <div style={{ display: "flex", marginBottom: "20px" }}>
              <div>
                <Skeleton
                  animation="wave"
                  variant="circular"
                  height={70}
                  width={70}
                />
              </div>

              <div>
                <Skeleton
                  animation="wave"
                  style={{ marginLeft: "20px" }}
                  variant="rectangular"
                  height={23}
                  width={50}
                />

                <Skeleton
                  style={{ marginLeft: "20px", marginTop: "20px" }}
                  animation="wave"
                  variant="rectangular"
                  height={23}
                  width={80}
                />
              </div>
            </div>
          ) : (
            <Fragment>
              <PageHeader
                pageName={usersData.brand.brand_name}
                heading={"Users"}
                iconImage={usersData.brand.brand_logo}
              />
            </Fragment>
          )}
        </Grid>
      </Grid>

      <UserList
        usersData={usersData}
        filterBy={filterBy}
        setFilterBy={setFilterBy}
      />
    </Fragment>
  );
}
